import React from "react";
import { Tab } from "semantic-ui-react";
import Deposit from "features/FolderManager/components/Deposit";

const DepositContent = ({ data, disabled, places, samplers, submit }) => {
	return (
		<Tab.Pane style={{ marginTop: 20 }}>
			<Deposit
				disabled={disabled}
				deposit={data.deposit}
				places={places}
				samplers={samplers}
				folderId={data.folders[0].id}
				submit={submit}
				fpa={data.prescriptions.flatMap((p) => p.scans || []).filter((s) => s.document_type && s.document_type.id === 2)}
			/>
		</Tab.Pane>
	);
};
export default DepositContent;
